import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';

import { LoginService } from '@VineyardLib/services/login.service';

export const canLoadMobileVersion: CanMatchFn = (
  route: Route,
  segments: UrlSegment[]
) => {
  if (!inject(LoginService).isAuthorized) {
    return inject(Router).navigate(['login']);
  }
  return isMobileDevice();
};

export const canLoadDesktopVersion: CanMatchFn = (
  route: Route,
  segments: UrlSegment[]
) => {
  if (!inject(LoginService).isAuthorized) {
    return inject(Router).navigate(['login']);
  }
  return !isMobileDevice();
};

export const isMobileDevice = (): boolean => {
  const userAgent: string = navigator.userAgent;
  //　userAgentをもとに端末を検出する正規表現
  //  参照：https://medium.com/better-programming/device-detection-in-typescript-198f76a7061a
  const regexs = [
    /(Android)(.+)(Mobile)/i,
    /BlackBerry/i,
    /iPhone|iPod/i,
    /Opera Mini/i,
    /IEMobile/i,
  ];
  // Androidは画面向きによってwidthとheightの値が逆になるため、小さいほうをwidthとする
  const screenWidth = Math.min(screen.availHeight, screen.availWidth);
  return regexs.some((b) => userAgent.match(b)) && screenWidth < 640;
};
